import { useCallback } from "react";

import groupBy from "lodash/groupBy";
import { useMutation } from "react-query";
import { getLanContent } from "utils";

import { masterDataWardListService } from "./services";

export const useWardListByIds = () => {
  const { mutateAsync: getListWard } = useMutation({
    mutationKey: "masterDataWardListServiceOption",
    mutationFn: masterDataWardListService,
  });

  const getListWardsByIds = useCallback(
    async (ids: number[], district: number) => {
      try {
        if (!ids?.length && !district) return {};

        const data = await getListWard({ ids, districtId: district });
        const dataTransform = data?.data?.items?.map((item) => ({
          id: item.id,
          name: getLanContent(item, "name"),
        }));
        return groupBy(dataTransform, "id") || [];
      } catch {
        return {};
      }
    },
    [getListWard]
  );

  return {
    getListWardsByIds,
  };
};
